import { render, staticRenderFns } from "./ThirdPartyPublicBetContent.vue?vue&type=template&id=643f5d54"
import script from "./ThirdPartyPublicBetContent.vue?vue&type=script&lang=js"
export * from "./ThirdPartyPublicBetContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports